// import readXlsxFile from 'read-excel-file';
import React from 'react';
import { Container, Row } from 'react-bootstrap';
import AllSales from './AllSales';
import { withAuthorization } from '../Session';

class Sales extends React.Component {
    constructor(props) {
        super(props);
        //console.log(this.props);
        this.state = {};
    }

    render() {
        return (
            <Container>
                <Row>
                    <h5 style={{ marginLeft: '1rem' }}>Sales History</h5>
                </Row>
                <div>
                    <hr />
                </div>
                <AllSales />
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(Sales);
